module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "hide"
  }, [_vm._v("Copyright")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_vm._v("Copyright © 2016 ")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph"
  }, [_c('span', {
    staticClass: "char-style-override-6"
  }, [_vm._v("By C")]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("apt ")]), _c('span', {
    staticClass: "char-style-override-6"
  }, [_vm._v("Robert Mueller, U.S. Coast Guard (ret)")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-2"
  }, [_c('span', {
    staticClass: "italics char-style-override-8"
  }, [_vm._v("The word “Pelican” and the depiction of a pelican are "), _c('br'), _vm._v("trademarks of Pelican Publishing Company, Inc. and are "), _c('br'), _vm._v("registered in the U.S. Patent and Trademark Office.")]), _c('span', {
    staticClass: "char-style-override-6"
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_vm._v("ISBN: 9781455622207")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_vm._v("E-book ISBN: 9781455622214")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "frame-2"
  }, [_c('img', {
    staticClass: "frame-4",
    attrs: {
      "alt": "28705.jpg",
      "src": "Images/28705.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-10"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-8"
  }, [_vm._v("Published by Pelican Publishing Company, Inc.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph para-style-override-11"
  }, [_c('span', {
    staticClass: "char-style-override-6"
  }, [_vm._v("1000 Burmaster Street, Gretna, Louisiana 70053")]), _c('span', {
    staticClass: "char-style-override-9"
  })]), _vm._v(" "), _c('p', {
    staticClass: "x-1-chapter-number"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5f17752","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Copyright.vue
// module id = 63
// module chunks = 0